import { render, staticRenderFns } from "./jiankangceping.vue?vue&type=template&id=11bb8c61&scoped=true&"
import script from "./jiankangceping.vue?vue&type=script&lang=ts&"
export * from "./jiankangceping.vue?vue&type=script&lang=ts&"
import style0 from "./jiankangceping.vue?vue&type=style&index=0&id=11bb8c61&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11bb8c61",
  null
  
)

export default component.exports